<template>
  <slice class="slice--loading skeleton"></slice>
</template>

<script>
import Slice from '@/components/Slices/Slice'

export default {
  name: 'LoadingSlice',
  components: {
    Slice,
  },
}
</script>

<style lang="scss">
.slice--loading {
  min-height: 100vh;
}
</style>
